import {AlertVariants} from '../../Alert/Alert';
import {TranslationInterpreter} from '../../TranslationProvider/TranslationProvider';

export const getDefaultMessage = (
  variant: AlertVariants | undefined,
  t: TranslationInterpreter
): string | undefined => {
  switch (variant) {
    case 'success':
      return t(`general.notifications.success`);
      break; // eslint-disable-line no-unreachable -- Muted pre-existing violation
    case 'warning':
      return t(`general.actions.warning`);
      break; // eslint-disable-line no-unreachable -- Muted pre-existing violation
    case 'error':
      return t(`general.notifications.error`);
      break; // eslint-disable-line no-unreachable -- Muted pre-existing violation
    case 'info':
      return t(`general.labels.information`);
      break; // eslint-disable-line no-unreachable -- Muted pre-existing violation
    default:
      return undefined;
  }
};
